var map = {
	"./r1-1.jpg": "68bb",
	"./r1.jpg": "eddc",
	"./r2.jpg": "1b6c",
	"./r3.jpg": "5d34",
	"./r4.jpg": "f992",
	"./r5.jpg": "2d53"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "394c";